module.exports = __webpack_public_path__ + "static/media/sad-emoji-svgrepo-com.2b7d9207.svg";